﻿"use strict";

//  is removed for PROD and a number for DEBUG so that functions can run side-by-side.

/* eslint-disable @typescript-eslint/no-unused-vars */
/* global console setInterval, clearInterval */

console.log("Loading custom functions from custom.js");

// What createQueryTaskAnchor reports back. These strings cross into C#: RegistrationAnchorService
// switches on them, so their values are a contract between the two sides, not a local detail.
const QUERY_TASK_ANCHOR_CREATED = "created";
const QUERY_TASK_ANCHOR_MISSING = "missing";
const QUERY_TASK_ANCHOR_BUSY = "busy";
let customFunctionService = null;
let registrationService = null;
window.queryTaskLocked = {};

// Receive the .NET object reference
function setCustomFunctionService(reference) {
    customFunctionService = reference;
    console.log("customFunctionService reference received.");
}

// Receive the .NET object reference backing QUERYTASKREGISTER
function setRegistrationService(reference) {
    registrationService = reference;
    console.log("registrationService reference received.");
}

/**
 * Gets a list of LemonEdge entity types
 * @customfunction GETMETADATA
 * @param {boolean} [includeHeaders] Whether to include the headers in the results. If omitted, includeHeaders = false.
 * @returns {string[][]} A list of entity types.
 */
async function getMetaData(includeHeaders) {
    try {
        return await customFunctionService.invokeMethodAsync("GetMetaData", includeHeaders ?? false);
    } catch (error) {
        return handleError(error);
    }
}

CustomFunctions.associate("GetMetaData", getMetaData);

/**
 * Retrieves data from a C# backend service for OData queries.
 * @customfunction GETODATA
 * @param {string} type The entity type to query (e.g., "Products", "Orders").
 * @param {boolean} [includeHeaders] Whether to include the headers in the results. If omitted, includeHeaders = false.
 * @param {string} [select] The fields to select, separated by commas (e.g., "Name,Price"). If ommitted, returns all.
 * @param {string} [filter] An optional OData filter expression to apply (e.g., "Price gt 20"). If ommitted, returns all.
 * @param {string} [orderby] An optional OData order by expression (e.g., "Name asc"). If ommitted, returns default.
 * @param {number} [count] An optional maximum number of results to retrieve. If ommitted, returns 500.
 * @returns {any[][]} The result set as a two-dimensional array.
 */
async function getOData(type, includeHeaders, select, filter, orderby, count) {
    try {
        return await customFunctionService.invokeMethodAsync("GetOData", type, includeHeaders ?? false, select, filter, orderby, count);
    } catch (error) {
        return handleError(error);
    }
}
CustomFunctions.associate("GetOData", getOData);

/**
 * Gets the parameter list for a query.
 * @customfunction GETQUERYPARAMETERS
 * @param {string} id The query id (GUID), or friendly name (takes the first if multiple found).
 * @param {boolean} [includeHeaders] Whether to include the headers in the results. If omitted, includeHeaders = false.
 * @param {boolean} [includeDefaults] Whether to include the default parameter set. If omitted, initialised as per platform settings.
 * @param {string} [selectHeaders] The fields to select, separated by commas (e.g., "Name,Price"). If ommitted, returns all.
 * @returns {any[][]} A list of entity types.
 */
async function getQueryParameters(id, includeHeaders, includeDefaults, selectHeaders) {
    try {
        return await customFunctionService.invokeMethodAsync("GetQueryParameters", id, includeHeaders ?? false, includeDefaults ?? false, selectHeaders);
    } catch (error) {
        return handleError(error);
        //debugger;
        //throw new CustomFunctionRuntime.error(CustomFunctionRuntime.ErrorType.invalidNumber, error.message || "An unexpected error occurred while fetching entity types.");
        ///*throw new CustomFunctions.error(CustomFunctions.errorType.invalidNumber, error.message || "An unexpected error occurred while fetching entity types.");*/
    }
}
CustomFunctions.associate("GetQueryParameters", getQueryParameters);

/**
 * Gets the parameter list for a query.
 * @customfunction QUERY
 * @param {string} id The query id (GUID), or friendly name (takes the first if multiple found).
 * @param {boolean} [includeHeaders] Whether to include the headers in the results. If omitted, includeHeaders = false.
 * @param {string} [selectHeaders] The fields to select, separated by commas (e.g., "Name,Price"). If ommitted, returns all.
 * @param {any[][][]} [args] The argument list - either the values mapped to the getQueryParameter list, or an explicit range defining names and values (as per the getQueryParameter output).
 * @param {CustomFunctions.Invocation} invocation The invocation context, used to identify the calling sheet.
 * @requiresAddress
 * @returns {any[][]} The result set.
 */
async function query(id, includeHeaders, selectHeaders, args, invocation) {
    try {
        return await customFunctionService.invokeMethodAsync("Query", id, includeHeaders ?? false, selectHeaders, false, invocation?.address ?? null, args);
    } catch (error) {
        return handleError(error);
    }
}
CustomFunctions.associate("Query", query);

/**
 * Gets the parameter list for a query.
 * @customfunction QUERYTASK
 * @param {string} id The query id (GUID), or friendly name (takes the first if multiple found).
 * @param {boolean} [includeHeaders] Whether to include the headers in the results. If omitted, includeHeaders = false.
 * @param {string} [selectHeaders] The fields to select, separated by commas (e.g., "Name,Price"). If ommitted, returns all.
 * @param {any[][][]} [args] The argument list - either the values mapped to the getQueryParameter list, or an explicit range defining names and values (as per the getQueryParameter output).
 * @param {CustomFunctions.Invocation} invocation The invocation context, used to identify the calling sheet.
 * @requiresAddress
 * @returns {any[][]} The result set.
 */
async function queryTask(id, includeHeaders, selectHeaders, args, invocation) {
    let start = null;
    try {
        console.time("interop-return");
        start = await customFunctionService.invokeMethodAsync(
            "StartQuery", id, includeHeaders ?? false, selectHeaders, invocation?.address ?? null, args);

        // Rows accumulate here on the JS heap; the C# side never holds more than one batch.
        const rows = start.headers ? [start.headers] : [];
        let batch;
        do {
            batch = await customFunctionService.invokeMethodAsync("GetNextBatch", start.opId);
            // Deliberately a loop, not rows.push(...batch.rows): the "..." would pass every row as a
            // separate argument to a single push call, and JS engines cap how many arguments one call
            // can take. Batch size is config (ResultBatchRows), so a large value would throw RangeError.
            for (const row of batch.rows) rows.push(row);
        } while (!batch.done);

        console.timeEnd("interop-return");
        console.log("rows back:", rows.length, "jsHeap MB:", (performance.memory?.usedJSHeapSize / 1048576).toFixed(0));
        return rows;
    } catch (error) {
        return handleError(error);
    } finally {
        if (start) {
            // Teardown on every exit; if this call itself fails, the C# idle sweep covers the cleanup.
            try { await customFunctionService.invokeMethodAsync("ReleaseQuery", start.opId); } catch { }
        }
    }
}
CustomFunctions.associate("QueryTask", queryTask);

/**
 * Registers this cell's query so it can be run later from the LemonEdge task pane. Runs nothing itself -
 * it records the query, its arguments and this cell's address. What the cell shows comes from the add-in,
 * not from the formula: the value held for this cell, or "Registered" until there is one.
 * @customfunction QUERYTASKREGISTER
 * @param {string} id The query id (GUID), or friendly name (takes the first if multiple found).
 * @param {boolean} [includeHeaders] Whether the run should include the headers in the results. If omitted, includeHeaders = false.
 * @param {string} [selectHeaders] The fields to select, separated by commas (e.g., "Name,Price"). If ommitted, returns all.
 * @param {any[][][]} [args] The argument list - either the values mapped to the getQueryParameter list, or an explicit range defining names and values (as per the getQueryParameter output).
 * @param {CustomFunctions.Invocation} invocation The invocation context, used to identify the calling cell.
 * @requiresAddress
 * @returns {any} The value held for this cell, or "Registered" until there is one.
 */
async function queryTaskRegister(id, includeHeaders, selectHeaders, args, invocation) {
    try {
        return await registrationService.invokeMethodAsync("RegisterQueryTask", id, includeHeaders ?? false, selectHeaders, invocation?.address ?? null, args);
    } catch (error) {
        return handleError(error);
    }
}
CustomFunctions.associate("QueryTaskRegister", queryTaskRegister);

// Registrations are stored in the workbook's own settings collection, so they travel inside the .xlsx and
// everyone who opens the file sees them. Excel gives an add-in no usable "closing" hook to save on, so the
// C# store writes through on every change (debounced) rather than waiting for the end of the session.
const QUERY_TASK_REGISTRATION_SETTING = "LemonEdge.QueryTaskRegistrations";

async function loadQueryTaskRegistrations() {
    if (!excelAvailable()) return null;
    return await Excel.run(async (context) => {
        const setting = context.workbook.settings.getItemOrNullObject(QUERY_TASK_REGISTRATION_SETTING);
        setting.load("value");
        await context.sync();
        return setting.isNullObject ? null : setting.value;
    });
}

async function saveQueryTaskRegistrations(json) {
    if (!excelAvailable()) return true;
    return await tryExcelWrite(async (context) => {
        // add() overwrites an existing setting of the same name.
        context.workbook.settings.add(QUERY_TASK_REGISTRATION_SETTING, json);
        await context.sync();
    });
}

/**
 * Excel refuses every workbook change while a cell is open for editing - the caret in a cell or in the
 * formula bar - and the add-in writes on a timer, so the two collide sooner or later. That is not a
 * failure, it is "not now".
 */
function isCellEditModeError(error) {
    return (
        error?.code === "InvalidOperationInCellEditMode" ||
        /cell-editing mode/i.test(error?.message ?? "")
    );
}

/**
 * Runs a batch that writes to the workbook, reporting whether it went through. Everything except the
 * cell-editing refusal is a real error and still throws.
 * @param {(context: Excel.RequestContext) => Promise<void>} write
 * @returns {Promise<boolean>} False when Excel was busy and the caller should try again later.
 */
async function tryExcelWrite(write) {
    try {
        await Excel.run(write);
        return true;
    } catch (error) {
        if (!isCellEditModeError(error)) throw error;
        console.log("Excel is in cell-editing mode; the write will be retried.");
        return false;
    }
}

function handleError(error) {
    return new CustomFunctions.Error(CustomFunctions.ErrorCode.invalidValue, error.message || "An unexpected error occurred while fetching entity types.");
}

// This still converts to a string - leaving here for reference.
function validArray(data) {
    if (!Array.isArray(data)) return data; // If it's not an array, return as is

    return data.map(row =>
        row.map(cell => {
            if (typeof cell === "string" && isValidDateString(cell)) {
                return new Date(cell);
            }
            return cell;
        })
    );
}

function isValidDateString(str) {
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,7})?([+-]\d{2}:\d{2}|Z)?$/.test(str);
}

async function getActiveSheetName() {
    return await Excel.run(async (context) => {
        const sheet = context.workbook.worksheets.getActiveWorksheet();
        sheet.load("name");
        await context.sync();
        return sheet.name;
    });
}

function isQueryTaskLocked(sheetName) {
    return window.queryTaskLocked[sheetName] === true;
}

function lockQueryTask(sheetName) {
    window.queryTaskLocked[sheetName] = true;
}

function unlockQueryTask(sheetName) {
    window.queryTaskLocked[sheetName] = false;
}

/**
 * Recalculates the given registered cells so each one re-invokes QUERYTASKREGISTER and picks up the value
 * now held for it. A targeted calculate() re-invokes even a clean, non-volatile custom function, which is
 * what lets the pane change what a formula cell shows without making the function volatile or forcing a
 * full workbook calculation (which would re-run every real QUERY and QUERYTASK too).
 * @param {string[]} addresses Cell addresses as recorded, e.g. "Sheet1!A1".
 */
async function recalculateQueryTaskCells(addresses) {
    if (!excelAvailable() || !addresses) return;
    // A single address is accepted as well as a list. Checked explicitly because a bare string has a
    // length and would otherwise slip past the guard and fail later on .map, pointing at the wrong line.
    if (typeof addresses === "string") addresses = [addresses];
    if (!Array.isArray(addresses)) throw new Error("recalculateQueryTaskCells expects an address or an array of them.");
    if (addresses.length === 0) return;
    // Suspended across the recalculation: the anchor sits inside its own result block, so the new value it
    // returns would otherwise come back as a change event and mark the results as edited.
    await withEventsSuspended(async (context) => {
        const targets = addresses.map((address) => {
            const separator = address.lastIndexOf("!");
            const name = separator > 0 ? unquoteSheetName(address.slice(0, separator)) : null;
            return {
                cell: separator > 0 ? address.slice(separator + 1) : address,
                sheet: name
                    ? context.workbook.worksheets.getItemOrNullObject(name)
                    : context.workbook.worksheets.getActiveWorksheet(),
            };
        });
        // Resolved first: a sheet that has since been deleted or renamed must be skipped rather than
        // throwing and taking the whole batch with it.
        targets.forEach((target) => target.sheet.load("isNullObject"));
        await context.sync();

        for (const target of targets) {
            if (target.sheet.isNullObject) {
                console.log("Skipping recalculation, sheet no longer exists for:", target.cell);
                continue;
            }
            target.sheet.getRange(target.cell).calculate();
        }
        await context.sync();
    });
}

/** A quoted sheet name escapes apostrophes by doubling them: 'My ''Big'' Sheet' -> My 'Big' Sheet. */
function unquoteSheetName(name) {
    const trimmed = name.trim();
    return trimmed.length >= 2 && trimmed.startsWith("'") && trimmed.endsWith("'")
        ? trimmed.slice(1, -1).replace(/''/g, "'")
        : trimmed;
}

/**
 * Starts watching the workbook for edits inside a registered result block. Registered once, on the
 * worksheet collection rather than per sheet, so sheets added later are covered too.
 *
 * The add-in's own writes never reach here: they run with workbook events suspended
 * (context.runtime.enableEvents = false), so what this reports is a person typing over a result.
 */
async function watchQueryTaskResultRanges() {
    if (!excelAvailable() || window.queryTaskResultWatchStarted) return false;
    window.queryTaskResultWatchStarted = true;
    try {
        // A session that was left with events off - by a write that failed before it could put them back -
        // would never raise any of the events being subscribed to here. Reloading the add-in repairs it.
        await restoreQueryTaskEvents();
        await Excel.run(async (context) => {
            context.workbook.worksheets.onChanged.add(onQueryTaskResultChanged);
            // A rename moves every address on that sheet, including the one each registration is keyed by.
            context.workbook.worksheets.onNameChanged.add(onQueryTaskSheetRenamed);
            // A deleted sheet takes its registrations with it.
            context.workbook.worksheets.onDeleted.add(onQueryTaskSheetDeleted);
            // Leaving a cell is when a write refused during editing can finally go through.
            context.workbook.worksheets.onSelectionChanged.add(onQueryTaskSelectionChanged);
            await context.sync();
            console.log("Watching query task results, and sheets being renamed or deleted.");
        });
        return true;
    } catch (error) {
        // `Excel` being defined is not the same as there being a workbook to watch. In a dialog window the
        // object model exists but has no document behind it, and subscribing throws from inside Office.js
        // rather than returning anything. Reported, not thrown: the add-in has to start regardless.
        window.queryTaskResultWatchStarted = false;
        console.log("Not watching query task results here: " + error.message);
        return false;
    }
}

// Change types that move cells about without any formula being edited. Each one leaves registrations
// pointing at addresses that have shifted under them, so the anchors are re-read.
const QUERY_TASK_STRUCTURAL_CHANGES = [
    "RowInserted",
    "RowDeleted",
    "ColumnInserted",
    "ColumnDeleted",
    "CellInserted",
    "CellDeleted",
];

async function onQueryTaskResultChanged(event) {
    try {
        if (!registrationService) return;
        if (QUERY_TASK_STRUCTURAL_CHANGES.includes(event.changeType)) {
            await registrationService.invokeMethodAsync("WorkbookStructureChanged");
        }
        // The event carries the sheet's id, not its name, and the address is bare - so it is qualified
        // here, because the add-in matches result blocks by sheet name.
        const address = await Excel.run(async (context) => {
            const sheet = context.workbook.worksheets.getItem(event.worksheetId);
            sheet.load("name");
            await context.sync();
            return `${sheet.name}!${event.address}`;
        });
        // The sheet id goes along with the address: it is what a registration matches on when the sheet
        // has been renamed since it was recorded.
        const marked = await registrationService.invokeMethodAsync(
            "ResultRangeChanged",
            event.worksheetId,
            address
        );
        if (marked?.length) console.log("Query task results edited at:", marked.join(", "));
    } catch (error) {
        // An event handler that throws takes the whole subscription down with it, and a missed mark is
        // not worth losing the watch over.
        console.log("Error handling a result range change: " + error.message);
    }
}

/**
 * Excel's own id for a sheet, which a rename does not change. Recorded against a registration so the
 * cell can still be found, and edits still recognised, after someone renames the tab.
 * @param {string} sheetName
 * @returns {Promise<string|null>} The id, or null if there is no such sheet.
 */
async function getQueryTaskSheetId(sheetName) {
    if (!excelAvailable() || !sheetName) return null;
    return await Excel.run(async (context) => {
        const sheet = context.workbook.worksheets.getItemOrNullObject(sheetName);
        sheet.load(["id", "isNullObject"]);
        await context.sync();
        return sheet.isNullObject ? null : sheet.id;
    });
}

/**
 * Selects a registered cell, bringing its sheet to the front and scrolling it into view.
 * @param {string|null} sheetId The recorded sheet id, tried first because it survives a rename.
 * @param {string|null} sheetName Fallback for a registration recorded before ids were kept.
 * @param {string} cellReference The cell within the sheet, e.g. "A1".
 * @returns {Promise<boolean>} False when the sheet is gone.
 */
async function goToQueryTaskCell(sheetId, sheetName, cellReference) {
    if (!excelAvailable() || !cellReference) return false;
    return await Excel.run(async (context) => {
        // getItem takes an id or a name, so both attempts are the same call.
        const byId = sheetId ? context.workbook.worksheets.getItemOrNullObject(sheetId) : null;
        const byName = sheetName ? context.workbook.worksheets.getItemOrNullObject(sheetName) : null;
        byId?.load("isNullObject");
        byName?.load("isNullObject");
        await context.sync();

        const sheet = byId && !byId.isNullObject ? byId : byName && !byName.isNullObject ? byName : null;
        if (!sheet) return false;

        sheet.activate();
        sheet.getRange(cellReference).select(); // selecting also scrolls it into view
        await context.sync();
        return true;
    });
}

/**
 * Selects a result block by its defined name. Preferred over the recorded address for the block, because
 * Excel maintains a name across inserted rows and columns where a stored address goes stale.
 * @param {string} rangeName
 * @returns {Promise<boolean>} False when the name no longer exists.
 */
async function goToQueryTaskRange(rangeName) {
    if (!excelAvailable() || !rangeName) return false;
    return await Excel.run(async (context) => {
        const name = context.workbook.names.getItemOrNullObject(rangeName);
        name.load("isNullObject");
        await context.sync();
        if (name.isNullObject) return false;

        const range = name.getRange();
        range.worksheet.activate();
        range.select();
        await context.sync();
        return true;
    });
}

/**
 * Moves registrations with their sheet when it is renamed. Without this they stay keyed by an address
 * that no longer exists, and the cell registers itself afresh - as a second entry, with none of the
 * first one's value or history.
 * @param {Excel.WorksheetNameChangedEventArgs} event
 */
async function onQueryTaskSheetRenamed(event) {
    try {
        if (!registrationService) return;
        const moved = await registrationService.invokeMethodAsync(
            "SheetRenamed",
            event.worksheetId,
            event.nameBefore,
            event.nameAfter
        );
        if (moved) console.log(`Sheet renamed to ${event.nameAfter}, moved ${moved} registration(s).`);
    } catch (error) {
        // As with the change handler: a throw here would take the whole subscription down.
        console.log("Error handling a sheet rename: " + error.message);
    }
}

/**
 * Creates the hidden defined name that anchors a registration to its cell. Excel maintains the name
 * through an inserted row or a renamed sheet - the changes to an address that Excel makes silently.
 * Hidden, so the user's Name Manager stays theirs.
 * @param {string} anchorName
 * @param {string|null} sheetId
 * @param {string|null} sheetName
 * @param {string} cellReference
 * @returns {Promise<boolean>} False when the sheet is gone.
 */
async function createQueryTaskAnchor(anchorName, sheetId, sheetName, cellReference) {
    if (!excelAvailable() || !anchorName || !cellReference) return QUERY_TASK_ANCHOR_MISSING;

    let outcome = QUERY_TASK_ANCHOR_CREATED;
    // Creating a name is a workbook change; it must not read back as a user editing the results.
    const written = await withEventsSuspended(async (context) => {
        const sheet = await resolveSheet(context, sheetId, sheetName);
        if (!sheet) {
            outcome = QUERY_TASK_ANCHOR_MISSING;
            return;
        }

        const existing = context.workbook.names.getItemOrNullObject(anchorName);
        existing.load("isNullObject");
        await context.sync();
        if (!existing.isNullObject) existing.delete();

        const named = context.workbook.names.add(anchorName, sheet.getRange(cellReference));
        named.visible = false;
        await context.sync();
    });

    // "busy" is not "missing": a registration must not be called an orphan just because the user happened
    // to be typing in a cell at the time.
    return written ? outcome : QUERY_TASK_ANCHOR_BUSY;
}

/**
 * Where each anchor now points. This is how a moved cell is noticed: the name followed the cell, the
 * stored address did not.
 * @param {string[]} anchorNames
 * @returns {Promise<Array<{name: string, address: string|null, sheetId: string|null, sheetName: string|null}>>}
 *          address is null when the name has gone or resolves to nothing - a deleted cell.
 */
async function resolveQueryTaskAnchors(anchorNames) {
    if (!excelAvailable() || !anchorNames || anchorNames.length === 0) return [];
    return await Excel.run(async (context) => {
        const lookups = anchorNames.map((name) => ({
            name,
            named: context.workbook.names.getItemOrNullObject(name),
        }));
        lookups.forEach((lookup) => lookup.named.load(["isNullObject", "type"]));
        await context.sync();

        // A deleted cell leaves the name behind pointing at #REF!, which comes back as type "Error".
        const live = lookups.filter((lookup) => !lookup.named.isNullObject && lookup.named.type !== "Error");
        live.forEach((lookup) => {
            lookup.range = lookup.named.getRangeOrNullObject();
            lookup.range.load(["isNullObject", "address"]);
            lookup.range.worksheet.load(["id", "name"]);
        });
        await context.sync();

        return lookups.map((lookup) => {
            const found = lookup.range && !lookup.range.isNullObject;
            return {
                name: lookup.name,
                address: found ? lookup.range.address : null,
                sheetId: found ? lookup.range.worksheet.id : null,
                sheetName: found ? lookup.range.worksheet.name : null,
            };
        });
    });
}

/**
 * Removes an anchor, for a registration being dropped.
 * @param {string} anchorName
 */
async function deleteQueryTaskAnchor(anchorName) {
    if (!excelAvailable() || !anchorName) return;
    await Excel.run(async (context) => {
        const named = context.workbook.names.getItemOrNullObject(anchorName);
        named.load("isNullObject");
        await context.sync();
        if (named.isNullObject) return;
        named.delete();
        await context.sync();
    });
}
/** The sheet for a recorded id or name, preferring the id because it survives a rename. */
async function resolveSheet(context, sheetId, sheetName) {
    const byId = sheetId ? context.workbook.worksheets.getItemOrNullObject(sheetId) : null;
    const byName = sheetName ? context.workbook.worksheets.getItemOrNullObject(sheetName) : null;
    byId?.load("isNullObject");
    byName?.load("isNullObject");
    await context.sync();
    return byId && !byId.isNullObject ? byId : byName && !byName.isNullObject ? byName : null;
}

/**
 * Every anchor name currently in the workbook. Used to collect the ones no registration claims any more -
 * a registration since removed, or a workbook edited while the add-in was not loaded.
 * @returns {Promise<string[]>}
 */
async function listQueryTaskAnchors() {
    if (!excelAvailable()) return [];
    return await Excel.run(async (context) => {
        const names = context.workbook.names;
        names.load("items/name");
        await context.sync();
        return names.items.map((item) => item.name).filter((name) => name.startsWith("LE_Anchor_"));
    });
}

/**
 * Removes several anchors in one batch.
 * @param {string[]} anchorNames
 */
async function deleteQueryTaskAnchors(anchorNames) {
    if (!excelAvailable() || !anchorNames || anchorNames.length === 0) return;
    await Excel.run(async (context) => {
        const named = anchorNames.map((name) => context.workbook.names.getItemOrNullObject(name));
        named.forEach((item) => item.load("isNullObject"));
        await context.sync();

        named.filter((item) => !item.isNullObject).forEach((item) => item.delete());
        await context.sync();
    });
}

/**
 * Leaving a cell is the first moment Excel will accept a write it refused during editing, so any save
 * still waiting is nudged through here rather than left to its timer.
 */
async function onQueryTaskSelectionChanged() {
    try {
        if (!registrationService) return;
        await registrationService.invokeMethodAsync("FlushPendingWrites");
    } catch (error) {
        console.log("Error flushing registrations after a selection change: " + error.message);
    }
}

/** Rows written per batch. Large results go in instalments rather than as one enormous range write. */
const QUERY_TASK_WRITE_CHUNK_ROWS = 500;

/**
 * Writes a query task's result into the sheet and names the block.
 *
 * The block starts at the formula's own cell, so the first row of results sits on the anchor row:
 * everything to the right of the anchor is written, and the anchor cell itself is left alone - the formula
 * lives there and shows that first value by returning it.
 * @param {string} address The registered cell, e.g. "Sheet1!A1".
 * @param {any[][]} rows The whole result.
 * @param {string} rangeName The defined name to give the block.
 * @param {string|null} previousBlock What the last run wrote, cleared first so a result with fewer rows or
 *        columns does not leave the old one's overhang behind.
 * @returns {Promise<string|null>} The block's address, or null when the sheet has gone.
 */
async function writeQueryTaskResult(address, rows, rangeName, previousBlock) {
    if (!excelAvailable() || !rows || rows.length === 0) return null;

    let blockAddress = null;
    // Our own writes must not read back as a user editing the results, and the recalculation that follows
    // would otherwise see the anchor's own new value as an edit.
    await withEventsSuspended(async (context) => {
        const separator = address.lastIndexOf("!");
        const sheet =
            separator > 0
                ? context.workbook.worksheets.getItemOrNullObject(unquoteSheetName(address.slice(0, separator)))
                : context.workbook.worksheets.getActiveWorksheet();
        sheet.load("isNullObject");
        await context.sync();
        if (sheet.isNullObject) return;

        const anchor = sheet.getRange(separator > 0 ? address.slice(separator + 1) : address);
        const columns = rows[0].length;

        // The last run's block goes first, or a narrower or shorter result leaves its overhang behind.
        await clearBlockAround(context, anchor, previousBlock);

        // Row one, minus the anchor cell: one column across, one column narrower.
        if (columns > 1) {
            anchor.getOffsetRange(0, 1).getResizedRange(0, columns - 2).values = [rows[0].slice(1)];
        }

        for (let start = 1; start < rows.length; start += QUERY_TASK_WRITE_CHUNK_ROWS) {
            const chunk = rows.slice(start, start + QUERY_TASK_WRITE_CHUNK_ROWS);
            anchor.getOffsetRange(start, 0).getResizedRange(chunk.length - 1, columns - 1).values = chunk;
            await context.sync();
        }

        const block = anchor.getResizedRange(rows.length - 1, columns - 1);

        // add() throws on a name that already exists, and a re-run always hits that, so the previous one
        // goes first.
        const existing = context.workbook.names.getItemOrNullObject(rangeName);
        existing.load("isNullObject");
        await context.sync();
        if (!existing.isNullObject) existing.delete();

        context.workbook.names.add(rangeName, block);
        block.load("address");
        await context.sync();
        blockAddress = block.address;
    });

    return blockAddress;
}

/** The fill shown over a result block whose parameters have moved on since it was produced. */
const QUERY_TASK_STALE_FILL = "#FFF2CC";

/**
 * Marks a result block as out of date: a light amber wash over the block, and a comment on the formula
 * cell, which Excel shows as a corner mark and reveals on hover.
 *
 * The wash is a conditional format rather than a fill. A fill would overwrite whatever formatting the
 * user has on those cells and could not be taken off again without guessing at what was underneath;
 * a conditional format layers on top and lifts off cleanly.
 * @param {string} resultRangeAddress The block to wash, e.g. "Sheet1!A1:E24".
 * @param {string} cellAddress The formula's own cell.
 * @param {string} message What the hover should say.
 * @returns {Promise<{formatId: string|null, commentId: string|null}>} The marks applied, to remove later.
 */
async function markQueryTaskStale(resultRangeAddress, cellAddress, message) {
    if (!excelAvailable() || !resultRangeAddress) return { formatId: null, commentId: null };

    let formatId = null;
    let commentId = null;
    await withEventsSuspended(async (context) => {
        const block = context.workbook.worksheets
            .getItemOrNullObject(sheetOf(resultRangeAddress))
            .getRange(referenceOf(resultRangeAddress));
        const stale = block.conditionalFormats.add(Excel.ConditionalFormatType.custom);
        // Always true: the rule is not a condition on the data, it is a wash over the whole block.
        stale.custom.rule.formula = "=TRUE";
        stale.custom.format.fill.color = QUERY_TASK_STALE_FILL;
        stale.load("id");

        const comment = context.workbook.comments.add(cellAddress, message);
        comment.load("id");
        await context.sync();

        formatId = stale.id;
        commentId = comment.id;
    });

    return { formatId, commentId };
}

/**
 * Takes the out-of-date marks off again, by the ids they were recorded under - so nothing the user applied
 * themselves is touched.
 * @param {string|null} resultRangeAddress Where the conditional format lives.
 * @param {string|null} formatId
 * @param {string|null} commentId
 */
async function clearQueryTaskStale(sheetAddress, formatId, commentId) {
    if (!excelAvailable() || (!formatId && !commentId)) return;
    await withEventsSuspended(async (context) => {
        if (formatId && sheetAddress) {
            const sheet = context.workbook.worksheets.getItemOrNullObject(sheetOf(sheetAddress));
            sheet.load("isNullObject");
            await context.sync();

            if (!sheet.isNullObject) {
                // Looked up across the whole sheet rather than within the block: by the time a mark is
                // cleared the block it was applied to may no longer be recorded - a run that comes back
                // with no rows discards it - and a format that cannot be found is a format left behind.
                const stale = sheet.getRange().conditionalFormats.getItemOrNullObject(formatId);
                stale.load("isNullObject");
                await context.sync();
                if (!stale.isNullObject) stale.delete();
            }
        }

        if (commentId) {
            const comment = context.workbook.comments.getItemOrNullObject(commentId);
            comment.load("isNullObject");
            await context.sync();
            if (!comment.isNullObject) comment.delete();
        }

        await context.sync();
    });
}

/** The sheet part of an address, unquoted. */
function sheetOf(address) {
    const separator = address.lastIndexOf("!");
    return separator > 0 ? unquoteSheetName(address.slice(0, separator)) : "";
}

/** The reference part of an address, without its sheet. */
function referenceOf(address) {
    const separator = address.lastIndexOf("!");
    return separator > 0 ? address.slice(separator + 1) : address;
}

/**
 * Runs a batch of writes with workbook events suspended, and puts them back whatever happens.
 *
 * enableEvents is session state, not something scoped to the batch: if a write throws between turning it
 * off and turning it back on, every event stays off for the rest of the session - the result watcher, the
 * rename watcher, all of it - and nothing says so. Hence the finally, and hence restoring in a batch of
 * its own, because a context whose sync has just failed cannot be relied on to carry one more instruction.
 * @param {(context: Excel.RequestContext) => Promise<void>} write
 * @returns {Promise<boolean>} False when Excel refused the write (cell-editing mode).
 */
async function withEventsSuspended(write) {
    try {
        return await tryExcelWrite(async (context) => {
            context.runtime.enableEvents = false;
            await context.sync();
            await write(context);
        });
    } finally {
        await restoreQueryTaskEvents();
    }
}

/** Turns workbook events back on. Safe to call when they are already on. */
async function restoreQueryTaskEvents() {
    if (!excelAvailable()) return;
    try {
        await Excel.run(async (context) => {
            context.runtime.enableEvents = true;
            await context.sync();
        });
    } catch (error) {
        console.log("Could not restore workbook events: " + error.message);
    }
}

/**
 * How many rows and columns an address spans, read from the address itself rather than by asking Excel -
 * the previous block's size is needed before anything is written over it.
 * @param {string} address e.g. "Sheet1!A1:E24"
 * @returns {[number, number]} rows, columns
 */
function sizeOf(address) {
    const corners = referenceOf(address).replace(/\$/g, "").split(":");
    if (corners.length < 2) return [1, 1];
    const first = cornerOf(corners[0]);
    const last = cornerOf(corners[1]);
    return [Math.abs(last.row - first.row) + 1, Math.abs(last.column - first.column) + 1];
}

/** A cell reference as numbers. Columns are base-26 with no zero: A = 1, Z = 26, AA = 27. */
function cornerOf(reference) {
    const match = /^([A-Za-z]*)(\d*)$/.exec(reference.trim());
    const letters = match?.[1] ?? "";
    const digits = match?.[2] ?? "";
    let column = 0;
    for (const letter of letters.toUpperCase()) column = column * 26 + (letter.charCodeAt(0) - 64);
    return { row: digits ? parseInt(digits, 10) : 1, column: column || 1 };
}

/**
 * Drops the registrations on a sheet that has just been deleted - there is no cell left to run from.
 * @param {Excel.WorksheetDeletedEventArgs} event
 */
async function onQueryTaskSheetDeleted(event) {
    try {
        if (!registrationService) return;
        const removed = await registrationService.invokeMethodAsync(
            "SheetDeleted",
            event.worksheetId,
            event.name ?? null
        );
        if (removed) console.log(`Sheet deleted, removed ${removed} registration(s).`);
    } catch (error) {
        // As with the other handlers: a throw would take the subscription down with it.
        console.log("Error handling a deleted sheet: " + error.message);
    }
}

/**
 * Clears a previously written result block, leaving the anchor cell alone - the formula lives there.
 * Contents only: the formatting is the user's. Cleared in the same two pieces the write uses.
 * @param {Excel.RequestContext} context
 * @param {Excel.Range} anchor The formula's own cell, which the block starts at.
 * @param {string|null} block What the last run wrote, e.g. "Sheet1!A1:E24".
 */
async function clearBlockAround(context, anchor, block) {
    if (!block) return;
    const [rows, columns] = sizeOf(block);
    if (columns > 1) {
        anchor.getOffsetRange(0, 1).getResizedRange(0, columns - 2).clear(Excel.ClearApplyTo.contents);
    }
    if (rows > 1) {
        anchor.getOffsetRange(1, 0).getResizedRange(rows - 2, columns - 1).clear(Excel.ClearApplyTo.contents);
    }
    await context.sync();
}

/**
 * Takes the last run's results off the sheet without writing anything in their place - for a run that came
 * back with no rows, where leaving the old block there would read as a result rather than as an empty one.
 * @param {string} address The registered cell.
 * @param {string|null} previousBlock What the last run wrote.
 */
async function clearQueryTaskResult(address, previousBlock) {
    if (!excelAvailable() || !previousBlock) return;
    await withEventsSuspended(async (context) => {
        const separator = address.lastIndexOf("!");
        const sheet =
            separator > 0
                ? context.workbook.worksheets.getItemOrNullObject(unquoteSheetName(address.slice(0, separator)))
                : context.workbook.worksheets.getActiveWorksheet();
        sheet.load("isNullObject");
        await context.sync();
        if (sheet.isNullObject) return;

        const anchor = sheet.getRange(separator > 0 ? address.slice(separator + 1) : address);
        await clearBlockAround(context, anchor, previousBlock);
    });
}

/**
 * Whether the Excel object model is reachable from here. Being loaded inside Office is not enough: a
 * dialog window runs this same app with no host document behind it, and every call into the workbook
 * fails there.
 */
function excelAvailable() {
    return typeof Excel !== "undefined";
}

/** Whether a formula is one of ours, whatever namespace prefix the deployment uses. */
function isRegistrationFormula(formula) {
    return typeof formula === "string" && formula.toUpperCase().includes("QUERYTASKREGISTER");
}

/**
 * Of the given cells, the ones that no longer hold a registration formula - cleared, or overwritten with
 * something else. A registration whose cell no longer runs anything has nothing left to run.
 * @param {string[]} addresses
 * @returns {Promise<string[]>} The addresses that have lost their formula, including those whose sheet has.
 */
async function queryTaskCellsWithoutFormula(addresses) {
    if (!excelAvailable() || !addresses || addresses.length === 0) return [];
    return await Excel.run(async (context) => {
        const cells = addresses.map((address) => {
            const sheet = context.workbook.worksheets.getItemOrNullObject(sheetOf(address));
            const range = sheet.getRange(referenceOf(address));
            sheet.load("isNullObject");
            range.load("formulas");
            return { address, sheet, range };
        });
        await context.sync();

        return cells
            .filter((cell) => cell.sheet.isNullObject || !isRegistrationFormula(cell.range.formulas?.[0]?.[0]))
            .map((cell) => cell.address);
    });
}
